var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('CustomDrawer'),_c('v-content',{staticStyle:{"background":"rgba(150, 153, 156, 0.15)"}},[_c('CustomNavbar'),_c('v-container',{staticClass:"px-3",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }